import { defineMessages } from "react-intl";

const messages = defineMessages({
  empty: {
    id: "fileStorage.components.empty.empty",
    defaultMessage: "There are no applications.",
  },
});

export default messages;
